import React, { useEffect, useRef, useState } from "react";
import { DatePicker, Form, Input, Modal, Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import dayjs from "dayjs";
import moment from "moment";

const { TextArea } = Input;

const AddCasualPaymentModal = ({ open, handleCancel, handleFetchData, prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { bank, loading } = useSelector((state) => state.dropdown);
  const { saving } = useSelector((state) => state.save);

  const [formData, setFormData] = useState(prodd);

  const onChange = async (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  function onMonthChange(value, formName) {
    setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  console.log("formData?.cpWorkStartdate",formData?.cpWorkStartdate)
  const onFinish = async (data) => {
    if (!formData?.cpWorkStartdate) {
      toast.error("Please add work start date");
      return;
    }
    if (!formData?.cpWorkEnddate) {
      toast.error("Please add work end date");
      return;
    }
    const res = await dispatch(
      save({
        cpId:prodd?.cpId  ?prodd?.cpId : null,
        cpWorkStartdate: formData?.cpWorkStartdate,   
        cpWorkEnddate:formData?.cpWorkEnddate,
        cpPaymentDesc:formData?.cpPaymentDesc,
        url: "hr/saveCasualPayment.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await setFormData({});
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };
 

  useEffect(() => {
    setFormData(prodd);
  }, [prodd]);

 

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={
          prodd
            ? `Edit casual payment ${prodd?.cpCpno}`
            : "Add casual payment details"
        }
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        > 
          <Form.Item
            rules={[
              {
                required: false,
                message: "Field is required",
              },
            ]}
            label="Work Start Date"
          >
            <DatePicker
              name="cpWorkStartdate" 
              className="input"
              placeholder={
                formData?.cpWorkStartdate
                  ? moment(formData.cpWorkStartdate)?.format("DD-MM-YYYY")
                  : "Select Date"
              }
              value={formData?.cpWorkStartdate ? dayjs(formData.cpWorkStartdate) : null}
              format={"DD-MM-YYYY"}
              onChange={(value) => {
                onMonthChange(value, "cpWorkStartdate");
              }}
            />
          </Form.Item>

          <Form.Item
            rules={[
              {
                required: false,
                message: "Field is required",
              },
            ]}
            label="Work End Date"
          >
            <DatePicker
              name="cpWorkEnddate" 
              className="input"
              placeholder={
                formData?.cpWorkEnddate
                  ? moment(formData.cpWorkEnddate)?.format("DD-MM-YYYY")
                  : "Select Date"
              }
              value={formData?.cpWorkEnddate ? dayjs(formData.cpWorkEnddate) : null}
              format={"DD-MM-YYYY"}
              onChange={(value) => {
                onMonthChange(value, "cpWorkEnddate");
              }}
            />
          </Form.Item>

          <Form.Item
            label="Payment Description"
            rules={[
              {
                required: true,
                message: "Enter Payment description",
              },
            ]}
          >
            <TextArea
              required
              rows={6}
              name="cpPaymentDesc"
              onChange={onChange}
              value={formData?.cpPaymentDesc}
              className="input"
            />
          </Form.Item>
     
         

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddCasualPaymentModal;
